export default "__VITE_ASSET__08c6494a__"